import { useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { X, ShieldCheck } from "lucide-react";

/** Modal shown when a guest tries to add to cart or buy now. */
export default function AuthRequiredModal({ open, onClose }) {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if (!open) return;
    const prev = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    const onKey = (e) => { if (e.key === "Escape") onClose(); };
    window.addEventListener("keydown", onKey);
    return () => { document.body.style.overflow = prev; window.removeEventListener("keydown", onKey); };
  }, [open, onClose]);

  if (!open) return null;

  const redirect = encodeURIComponent(location.pathname + location.search);
  const go = (tab) => {
    onClose();
    navigate(`/login?tab=${tab}&redirect=${redirect}`);
  };

  return (
    <div
      className="fixed inset-0 z-[160] bg-brand-dark/55 backdrop-blur-sm flex items-center justify-center p-4 animate-fade-in"
      onClick={(e) => { if (e.target === e.currentTarget) onClose(); }}
      data-testid="auth-required-modal"
    >
      <div className="bg-white rounded-2xl w-full max-w-sm overflow-hidden shadow-2xl">
        <div className="px-6 pt-6 pb-3 flex items-start justify-between gap-3">
          <div className="flex items-center gap-3">
            <span className="w-10 h-10 rounded-full bg-brand-subtle text-brand-chili flex items-center justify-center">
              <ShieldCheck className="w-5 h-5" strokeWidth={1.6} />
            </span>
            <h3 className="font-serif text-2xl text-brand-dark">Sign in to continue</h3>
          </div>
          <button onClick={onClose} aria-label="Close" className="p-1 -mt-1 text-brand-muted active:text-brand-chili" data-testid="auth-required-cancel">
            <X className="w-5 h-5" />
          </button>
        </div>
        <p className="px-6 pb-6 text-sm text-brand-muted leading-relaxed">
          Please sign in or create an account to continue.
        </p>
        <div className="px-6 pb-6 grid grid-cols-2 gap-3">
          <button type="button" onClick={() => go("signin")} className="btn-primary !text-sm" data-testid="auth-required-signin">
            Sign in
          </button>
          <button type="button" onClick={() => go("signup")} className="btn-outline !text-sm" data-testid="auth-required-signup">
            Sign up
          </button>
        </div>
      </div>
    </div>
  );
}
